export default __webpack_public_path__ + "static/media/Logo.35e45a90.svg";